import gsap from "gsap";
import * as THREE from "three";
const createInputEvents = require("simple-input-events");



let scrollOffset = 0;
let dir = new THREE.Vector2();
let lastuv = [0.5, 0.5];
let parallaxEnabled = true;
let parent = document.querySelector(".topmirror");
let frag1,frag2,frag3,frag4;
if(parent) {
  frag1 = parent.querySelector(".copy1").querySelector(".mirror__wraptext");
  frag2 = parent.querySelector(".copy2").querySelector(".mirror__wraptext");
  frag3 = parent.querySelector(".copy3").querySelector(".mirror__wraptext");
  frag4 = parent.querySelector(".copy4").querySelector(".mirror__wraptext");
}
function initTopMirror() {
  
  let imagesWrapper = parent.querySelector(".topmirror__images");
  const event = createInputEvents(parent);

  // @todo - wait for FONT load with font ovebserver

  setTimeout(() => {
    if(imagesWrapper) imagesWrapper.classList.remove("is-hidden");
  }, 500);

  if(window.locoScroll) window.locoScroll.on("scroll", (args) => {
    if (typeof args.currentElements["topmirror"] === "object") {
      let progress = args.currentElements["topmirror"].progress;
      scrollOffset = progress;
      updateFragments(lastuv, scrollOffset);
    }
  });

  event.on("move", ({ uv }) => {
    lastuv = uv;
    if (parallaxEnabled) {
      updateFragments(uv, scrollOffset);
    }
  });
}

function updateFragments(uv, offset) {
  // let ease = 'power3.out'
  let ease = "power1.out";
  let duration = 0.5;
  let dist = (uv[0] - 0.5) ** 2 + (uv[1] - 0.5) ** 2 + scrollOffset;
  dir
    .set(uv[0] - 0.5, uv[1] - 0.5)
    .normalize()
    .multiplyScalar(dist * 3);
  gsap.to(frag1, {
    x: dir.x * 30,
    y: dir.y * 20,
    duration: duration,
    overwrite: true,
    ease: ease,
  });
  gsap.to(frag2, {
    x: -dir.x * 30,
    y: dir.y * 20,
    duration: duration,
    overwrite: true,
    ease: ease,
  });
  gsap.to(frag3, {
    x: dir.x * 40,
    y: dir.y * 30,
    duration: duration,
    overwrite: true,
    ease: ease,
  });
  gsap.to(frag4, {
    x: dir.x * 30,
    y: -dir.y * 20,
    duration: duration,
    overwrite: true,
    ease: ease,
  });
}

if (parent) initTopMirror();
